export const INITIAL_CUSTOM_MEDICAL_ITEM_VALUES = {
  providerId: null,
  settlementType: null,
  settledAmount: "",
};

export const normalizeIdValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return null;
  }

  const numericValue = Number(value);

  return Number.isNaN(numericValue) ? value : numericValue;
};

export const mapSettlementTypeOption = (option) => ({
  id: normalizeIdValue(option?.value ?? null),
  label: option?.display_name ?? "",
});

export const mapProviderOption = (option) => ({
  id: normalizeIdValue(option?.key ?? null),
  label: option?.label ?? option?.value ?? "",
});

export const hasCompleteCustomMedicalItemValues = (formValues) =>
  formValues.providerId !== null &&
  formValues.providerId !== undefined &&
  formValues.providerId !== "" &&
  formValues.settlementType !== null &&
  formValues.settlementType !== undefined &&
  formValues.settlementType !== "" &&
  formValues.settledAmount !== "";

export const hasAnyCustomMedicalItemValues = (formValues) =>
  formValues.providerId !== null ||
  formValues.settlementType !== null ||
  formValues.settledAmount !== "";
